/**
 * @param {Object} doc        document object
 * @param {String} clickable  boolean
 *
 */
import {
  humanizedReviewStatus,
  reviewStatusColor,
  reviewStatusIconType,
  setReviewStatusAriaLabel
} from '../pages/admin/document_review_status'
import {
  humanizedSeverityStatus,
  severityStatusColor
} from '../pages/admin/document_severity_status'

export default function setupRiskTags(doc, clickable = false) {
  const riskTags = []
  const reviewStatus = doc.document_scan
    ? doc.document_scan.review_status
    : null
  const severity = doc.document_scan ? doc.document_scan.severity : null
  const isStatusClickable = !!reviewStatus && !!severity && clickable
  const isSeverityClickable = !!severity && severity !== 'na' && clickable

  riskTags.push({
    text: humanizedReviewStatus(reviewStatus),
    type: reviewStatusColor(reviewStatus),
    clickable: isStatusClickable,
    icon: isStatusClickable ? 'check-circle' : '',
    icon_type: reviewStatusIconType(reviewStatus),
    value: reviewStatus,
    tag_name: 'review_status',
    aria_label: setReviewStatusAriaLabel(reviewStatus)
  })

  riskTags.push({
    text: humanizedSeverityStatus(severity),
    type: severityStatusColor(severity),
    clickable: isSeverityClickable,
    icon: isSeverityClickable ? 'info-circle' : '',
    icon_type: 'regular',
    value: severity,
    tag_name: 'severity'
  })
  return riskTags
}
